module.exports = __webpack_public_path__ + "img/phone.ed33c289.png";